// ChatHistory.jsx
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Input, Modal, Header, Image, Popup } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import {
  getRadioDataActionSet,
  getChatHistory,
  deleteChatHistoryData,
  editChatHistoryData,
  DeleteChatHistorySuccess,
  ListChatHistoryRequestSuccess,
  EditChatHistorySuccess,
  ChatHistoryFilterSuccess,
  getChatHistoryByFilter,
} from "../../actions/dataConsoleAction";
import { getChatHistoryData, getChatHistoryByFiltering } from "../../apis/index";
import "../../styles/AiAssistant.css";
import "../../styles/ChatScreen.css";
import Loader from "../../components/Loader";
import { formatMessageTimestampWithTz } from "../../utils/formatMessageTimestamp";
import { set } from "react-hook-form";

function resolveCreatedByUserId(createdBy) {
  if (!createdBy) return null;
  if (typeof createdBy === "string") return createdBy;
  return (
    createdBy.id ||
    createdBy.userId ||
    createdBy.oid ||
    createdBy.objectId ||
    createdBy.user_id ||
    null
  );
}

function resolveRequesterIdFromChat(chat) {
  if (!chat) return null;
  return chat.userId || resolveCreatedByUserId(chat.createdBy);
}

function resolveRequesterNameFromChat(chat) {
  if (!chat) return null;
  const { createdBy } = chat;
  if (createdBy && typeof createdBy === "object") {
    return (
      createdBy.display_name ||
      createdBy.username ||
      createdBy.name ||
      createdBy.email ||
      null
    );
  }
  return chat.userName || chat.username || null;
}

const HUMAN_AGENT_HISTORY_WINDOW = "humanAgentHistoryView";

const ChatHistory = ({
  dataFromChild,
  filterdataFromChild,
  onClearFilteredFromChild,
  clearFilterFromChild,
  onStartDateClear,
  isFilterPopUpClick,
  handleFilterSort,
  onOutsideClick,
  isChatHistory,
  isChatHistoryCreated,
  chatHistoryLoaded,
  setChatHistoryLoaded,
  updateOutsideFunc,
  eventName,
  eventId,
  showToaster,
  ChatHistoryOpen,
  setIsChatView,
  setHandleViewCalled,
  handleViewCalled,
  closeMobileChatHistory,
}) => {
  // console.log("filterdataFromChild", filterdataFromChild);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { responseChatHistory, chatHistoryStatus, loadingsChatHistory, chatHistoryPagination, loadingMoreChatHistory } = useSelector(
    (state) => state.chatHistoryRed || {}
  );
  const { responseRadioDataList, dataSetinitialRadioStateStatus } = useSelector(
    (state) => state.listDatasetRadioReducer || {}
  );

  const { deleteChatHistoryResponseData, deleteChatHistoryStatus } =
    useSelector((state) => state.deleteChatHistory || {});

  const { editData, editDataStatus } = useSelector(
    (state) => state.editChatHistory || {}
  );

  const { filterData, filterDataStatus, filterPagination } = useSelector(
    (state) => state.chatHistoryFilterData || {}
  );

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chatBotQueryParam = queryParams.get("cid");
  const requesterIdFromUrl = queryParams.get("requesterId");
  const requesterNameFromUrl = queryParams.get("requesterName");
  const isHistoryViewTab = queryParams.get("historyView") === "1";
  const scopedRequesterIdRef = useRef(requesterIdFromUrl || null);
  const scopedRequesterNameRef = useRef(requesterNameFromUrl || null);
  const [requesterDisplayName, setRequesterDisplayName] = useState(requesterNameFromUrl || "");
  const isMounted = useRef(true);
  const isMountedChatHistory = useRef(true);
  const [data, setData] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [tooltip, setTooltip] = useState(null);
  const [dataset, setDataset] = useState([]);
  const [isDeleteFlag, setIsDeleteFlag] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [chatInputValue, setChatInputValue] = useState("");
  const [isEditSuccess, setIsEditSuccess] = useState(false);
  const [isClearFlag, setIsClearFlag] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [deleteFlag, setdeleteFlag] = useState(false);
  const [deleteChatName, setDeleteChatName] = useState("");
  const [deleteHistoryId, setDeleteHistoryId] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginedUserName, setloginedUserName] = useState("");
  const [loginedUserType, setloginedUserType] = useState("");
  const currentUserType = useSelector((state) => state.auth.user);
  const isHumanAgent = currentUserType === "HumanAgent";
  const userToken = useSelector((state) => state.auth.token);
  const [showLoader, setShowLoader] = useState(false);
  const [MobileSettingsOpenFlag, setopenMobileSettingsOpenFlag] =
    useState(false);
  const [openMobileSettings, setopenMobileSettings] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [isClearFilter, setIsClearFilter] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedChatId, setSelectedChatId] = useState(null);
  const scrollRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const isFetchingRef = useRef(false);
  const lastLoadedPageRef = useRef(0);
  const filterQueryRef = useRef("");
  const searchRef = useRef("");
  const searchDebounceRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      deleteChatHistoryResponseData != undefined &&
      deleteChatHistoryStatus === 200 &&
      isDeleteFlag
    ) {
      showToaster("Chat history deleted successfully", "success");
      dispatch(DeleteChatHistorySuccess([]));
      dispatch(EditChatHistorySuccess([]));
      setShowLoader(false);
      setIsDeleteFlag(false);
      chatData(currentUserType, userToken);
      setopenMobileSettingsOpenFlag(!MobileSettingsOpenFlag);
    }
  }, [deleteChatHistoryResponseData, deleteChatHistoryStatus, isDeleteFlag]);

  useEffect(() => {
    if (editDataStatus === 200 && isEditSuccess) {
      showToaster("Chat history updated successfully", "success");
      setIsEditSuccess(false);
      // Ensure the data is not reset to any old state
    }
  }, [editData, editDataStatus, isEditSuccess]);




  const wrapperRef = useRef(null);

  let filterStDate;
  let filterEdDate;
  if (filterdataFromChild && filterdataFromChild.startDate) {
    const parts = filterdataFromChild.startDate.split("/");
    filterStDate = parts[2] + "-" + parts[0] + "-" + parts[1];
  }
  if (filterdataFromChild && filterdataFromChild.endDate) {
    const parts = filterdataFromChild.endDate.split("/");
    filterEdDate = parts[2] + "-" + parts[0] + "-" + parts[1];
  }

  // Build and store the filter query string for pagination
  useEffect(() => {
    if (filterdataFromChild && clearFilterFromChild) {
      const fromDate = filterdataFromChild.startDate
        ? (() => { const p = filterdataFromChild.startDate.split("/"); return `${p[2]}-${p[0]}-${p[1]}`; })()
        : "";
      const toDate = filterdataFromChild.endDate
        ? (() => { const p = filterdataFromChild.endDate.split("/"); return `${p[2]}-${p[0]}-${p[1]}`; })()
        : "";
      const datasetIds = filterdataFromChild.datasets ? filterdataFromChild.datasets.join(",") : "";
      const userIds = filterdataFromChild.users ? filterdataFromChild.users.join(",") : "";
      filterQueryRef.current = `?fromDate=${fromDate}&toDate=${toDate}&datasetIds=${datasetIds}&userIds=${userIds}`;
      // Reset pagination refs for new filter
      lastLoadedPageRef.current = 0;
      isFetchingRef.current = false;
      setCurrentPage(1);
      // Scroll the chat history list back to the top so users see results from the beginning
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }
  }, [filterdataFromChild, clearFilterFromChild]);

  let ui = "";

  useEffect(() => {
    setloginedUserName(userToken.name);
    setloginedUserType(currentUserType);
  }, [currentUserType, userToken]);

  const searchResult = (data) => {
    let results;
    let groupedData = [];
    if (data && data.length > 0) {
      groupedData = data.reduce((result, item) => {
        const {
          updatedUTC,
          title,
          datasetName,
          datasetId,
          id,
          createdBy,
          ...rest
        } = item;
        // Convert ModifiedDate to local date
        const localDate = moment.utc(updatedUTC).local().format("YYYY-MM-DD");

        // Find the group for the local date
        const dateGroup = result.find((group) => group.localDate === localDate);

        if (dateGroup) {
          // Add Chathistoryinfo to the existing local date group
          dateGroup.Chathistoryinfo.push({
            Datasetname: datasetName,
            DatasetID: datasetId,
            chathistoryname: title,
            createdBy: createdBy,
            id: id,
            updatedUTC: updatedUTC,
          });
        } else {
          // Create a new local date group
          result.push({
            localDate,
            ...rest,
            Chathistoryinfo: [
              {
                Datasetname: datasetName,
                DatasetID: datasetId,
                chathistoryname: title,
                createdBy: createdBy,
                id: id,
                updatedUTC: updatedUTC,
              },
            ],
          });
        }
        return result;
      }, []);
    }

    groupedData.sort((a, b) => {
      return new Date(b.localDate) - new Date(a.localDate);
    });

    setLoading(false);
    results = groupedData;
    setData(results);
    if (!results || results.length === 0) {
      setLoading(true);
    }
  };

  const resolveAnchorChatByCid = async () => {
    const firstPage = await getChatHistoryData(1, 100, searchRef.current || "");
    let records = firstPage?.data?.data || firstPage?.data || [];
    if (!Array.isArray(records)) records = [];

    let anchorChat = records.find((c) => c.id === chatBotQueryParam);
    const totalPages = firstPage?.data?.pagination?.totalPages || 1;
    if (!anchorChat && totalPages > 1) {
      const maxPage = Math.min(totalPages, 5);
      for (let page = 2; page <= maxPage && !anchorChat; page++) {
        const next = await getChatHistoryData(page, 100, searchRef.current || "");
        const pageRecords = next?.data?.data || next?.data || [];
        if (Array.isArray(pageRecords)) {
          anchorChat = pageRecords.find((c) => c.id === chatBotQueryParam);
        }
      }
    }

    return anchorChat || null;
  };

  const loadRequesterHistory = async (requesterId) => {
    const qs = `?fromDate=&toDate=&datasetIds=&userIds=${encodeURIComponent(requesterId)}`;
    filterQueryRef.current = qs;
    const filtered = await getChatHistoryByFiltering(
      qs,
      1,
      100,
      searchRef.current || ""
    );
    let scoped = filtered?.data?.data || filtered?.data || [];
    if (!Array.isArray(scoped)) scoped = [];
    scoped = scoped.filter((c) => resolveRequesterIdFromChat(c) === requesterId);

    return scoped;
  };

  const buildHistoryUrl = (id, datasetName, datasetID, { includeHistoryView = false } = {}) => {
    let url = `/aiassistant?c=${datasetID}&cid=${id}&title=${encodeURIComponent(datasetName || "")}`;
    const requesterId = scopedRequesterIdRef.current || requesterIdFromUrl;
    if (requesterId) {
      url += `&requesterId=${encodeURIComponent(requesterId)}`;
    }
    const requesterName = scopedRequesterNameRef.current || requesterNameFromUrl;
    if (requesterName) {
      url += `&requesterName=${encodeURIComponent(requesterName)}`;
    }
    if (includeHistoryView) {
      url += "&historyView=1";
    }
    return url;
  };

  const updateRequesterDisplayName = (anchorChat, scopedList) => {
    const name =
      requesterNameFromUrl ||
      scopedRequesterNameRef.current ||
      resolveRequesterNameFromChat(anchorChat) ||
      resolveRequesterNameFromChat(scopedList?.[0]) ||
      "";
    scopedRequesterNameRef.current = name || null;
    setRequesterDisplayName(name);
  };

  // HumanAgent: scope sidebar history to the end-user tied to the current cid.
  useEffect(() => {
    if (!isHumanAgent) return undefined;

    let cancelled = false;

    const loadRequesterScopedHistory = async () => {
      if (!chatBotQueryParam) {
        setData([]);
        setRequesterDisplayName("");
        scopedRequesterNameRef.current = null;
        setLoading(true);
        setShowLoader(false);
        setChatHistoryLoaded(true);
        return;
      }

      setShowLoader(true);
      setLoading(false);
      try {
        let requesterId = requesterIdFromUrl || scopedRequesterIdRef.current;
        let anchorChat = null;

        if (!requesterId || !scopedRequesterNameRef.current) {
          anchorChat = await resolveAnchorChatByCid();
          if (cancelled) return;
          if (!requesterId) {
            requesterId = resolveRequesterIdFromChat(anchorChat);
          }
        }

        scopedRequesterIdRef.current = requesterId || null;

        if (!requesterId) {
          updateRequesterDisplayName(anchorChat, []);
          searchResult([]);
          return;
        }

        const scoped = await loadRequesterHistory(requesterId);
        if (cancelled) return;
        updateRequesterDisplayName(anchorChat, scoped);
        searchResult(scoped);
      } catch (err) {
        console.error("HumanAgent requester history failed:", err);
        if (!cancelled) searchResult([]);
      } finally {
        if (!cancelled) {
          setShowLoader(false);
          setChatHistoryLoaded(true);
        }
      }
    };

    loadRequesterScopedHistory();
    return () => {
      cancelled = true;
    };
  }, [isHumanAgent, chatBotQueryParam, requesterIdFromUrl, requesterNameFromUrl]);

  // get chat history data
  const getChatHistoryListingData = (page = 1) => {
    if (isHumanAgent) return;
    try {
      dispatch(getChatHistory(page, 20, searchRef.current));
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }

  };

  // Determine if we're in filter mode
  const isFilterMode = clearFilterFromChild && filterData && filterData.length > 0;

  // Active pagination depends on mode
  const activePagination = isFilterMode ? filterPagination : chatHistoryPagination;

  const hasMorePages = activePagination
    ? activePagination.page < activePagination.totalPages
    : false;

  const handleScroll = useCallback(() => {
    if (isHumanAgent) return;
    const container = scrollRef.current;
    if (!container) return;
    if (isFetchingRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

    if (scrollPercentage >= 0.7 && hasMorePages) {
      const nextPage = (activePagination?.page || 1) + 1;
      // Guard: never re-fetch a page we already loaded or are loading
      if (nextPage <= lastLoadedPageRef.current) return;

      isFetchingRef.current = true;
      setIsFetchingMore(true);
      setCurrentPage(nextPage);

      if (isFilterMode && filterQueryRef.current) {
        dispatch(getChatHistoryByFilter(filterQueryRef.current, nextPage, 20, searchRef.current));
      } else {
        getChatHistoryListingData(nextPage);
      }
    }
  }, [hasMorePages, activePagination, isFilterMode]);

  useEffect(() => {
    if (activePagination) {
      lastLoadedPageRef.current = activePagination.page;
      isFetchingRef.current = false;
      setIsFetchingMore(false);
    }
  }, [activePagination]);

  useEffect(() => {
    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const chatData = (UserType, userToken) => {
    try {
      dispatch(getRadioDataActionSet());
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };
  const chatHistoryEdit = (id, chat) => {
    setChatInputValue(chat);
    setIsEditable(id);
    if (chat.length > 50) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  };

  const chatEventUpdate = (e, id) => {
    // setChatInputValue(e.target.value);
    // updateOutsideFunc({ event: e.target.value, eventId: id });
    const value = e.target.value;
    if (value.length < 50) {
      setChatInputValue(value);
      updateOutsideFunc({ event: e.target.value, eventId: id });
      setShowWarning(false);
    } else {
      setShowWarning(true);
    }
  };

  useEffect(() => {
    if (isHumanAgent) return;
    if (isMounted.current || isClearFilter || isEditSuccess) {
      chatData(currentUserType, userToken);
      isMounted.current = false;
      setIsClearFilter(false);
      setIsEditSuccess(false);
      setIsEditable(false);
      setopenMobileSettings(false);
      setShowWarning(false);
      setopenMobileSettingsOpenFlag(false);
    }
    if (
      responseRadioDataList !== undefined &&
      dataSetinitialRadioStateStatus !== undefined &&
      dataSetinitialRadioStateStatus === 200
    ) {
      setDataset(responseRadioDataList);
    }
  }, [
    responseRadioDataList,
    isEditSuccess,
    currentUserType,
    userToken,
    isClearFilter,
    isHumanAgent,
  ]);

  useEffect(() => {
    if (isHumanAgent) return;
    if (isChatHistory) {
      setCurrentPage(1);
      lastLoadedPageRef.current = 0;
      isFetchingRef.current = false;
      getChatHistoryListingData(1);
      isChatHistoryCreated(false);
      setChatHistoryLoaded(true);
      isMountedChatHistory.current = false;
    } else if (dataset.length > 0 && !chatHistoryLoaded) {
      setCurrentPage(1);
      lastLoadedPageRef.current = 0;
      isFetchingRef.current = false;
      getChatHistoryListingData(1);
      setChatHistoryLoaded(true);
      isMountedChatHistory.current = false;
    }
  }, [dataset, isChatHistory]);

  useEffect(() => {
    if (isHumanAgent) return;
    if (chatBotQueryParam && !chatHistoryLoaded) {
      setCurrentPage(1);
      lastLoadedPageRef.current = 0;
      isFetchingRef.current = false;
      getChatHistoryListingData(1);
      setChatHistoryLoaded(true);
    }
  }, [dataset, chatBotQueryParam]);



  useEffect(() => {
    if (isHumanAgent) return;
    if (filterData && filterData.length > 0 && clearFilterFromChild) {
      searchResult(filterData);
      // setShowLoader(false);
    } else if (
      filterdataFromChild &&
      clearFilterFromChild &&
      (filterdataFromChild.startDate || filterdataFromChild.endDate)
    ) {
      searchResult(filterData);
    } else if (
      responseChatHistory !== undefined &&
      responseChatHistory.length > 0
    ) {
      searchResult(responseChatHistory);
    } else {
      setLoading(true);
    }
  }, [dataset, responseChatHistory, filterData, filterDataStatus]);

  const handleClickOutside = ({ onOutsideClick }) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      // Click occurred outside the component
      try {
        const editObj = new FormData();
        editObj.append(
          "json",
          JSON.stringify({
            newname: eventName,
            id: eventId,
          })
        );
        dispatch(editChatHistoryData(editObj));
        setIsEditSuccess(true);
        setopenMobileSettings(false);
        setShowWarning(false);
        setopenMobileSettingsOpenFlag(false);
      } catch (error) {
        console.error("Error in update chat name:", error);
      }
      setIsEditable(false);
      setShowWarning(false);
    }
  };

  useEffect(() => {
    // Attach event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    //Detach event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick]);

  const isMobile = windowWidth <= 768;
  const handleView = (id, datasetName, datasetID) => {
    setSelectedChatId(id);
    setHandleViewCalled(true);
    handleViewCalled();

    const url = buildHistoryUrl(id, datasetName, datasetID, {
      includeHistoryView: isHumanAgent,
    });

    if (isHumanAgent) {
      if (isHistoryViewTab) {
        navigate(url);
      } else {
        const historyWindow = window.open(url, HUMAN_AGENT_HISTORY_WINDOW);
        historyWindow?.focus();
      }
      return;
    }

    if (isMobile) {
      setIsChatView(true);
      closeMobileChatHistory();
    }
    navigate(url);
  };

  const handleEdit = async (e, id) => {
    if (isHumanAgent) return;
    if (e.key === "Enter") {
      const newTitle = e.target.value;

      // Optimistically update the local state to reflect the new title
      const updatedData = data.map((item) => {
        const updatedHistoryInfo = item.Chathistoryinfo.map((history) => {
          if (history.id === id) {
            return { ...history, chathistoryname: newTitle };
          }
          return history;
        });

        return { ...item, Chathistoryinfo: updatedHistoryInfo };
      });

      setData(updatedData);  // Update the state immediately
      setIsEditable(false);  // Close the edit mode (hide input field)
      setopenMobileSettings(false);  // Hide the edit popup/modal

      try {

        const payload = { title: newTitle };
        await dispatch(editChatHistoryData(payload, id));


        showToaster("Chat history updated successfully", "success");

      } catch (error) {
        console.error("Error in editing chat history:", error);
        showToaster("Error updating chat history", "error");

      }
    }
  };



  const handleDelete = async (chatHistoryId, chatName) => {
    if (isHumanAgent) return;
    setDeleteChatName(chatName);
    setDeleteHistoryId(chatHistoryId);
    setopenDeleteBox(true);
  };

  const actionDeleteChatHistory = async () => {
    setopenDeleteBox(false);
    try {
      setShowLoader(true);
      setIsDeleteFlag(true);
      dispatch(deleteChatHistoryData(deleteHistoryId));
    } catch (error) {
      console.error("Error in delete chat History:", error);
    }
  };

  const clearFilter = () => {
    onClearFilteredFromChild(false);
    setIsClearFilter(true);
    handleFilterSort();
    dispatch(ChatHistoryFilterSuccess([]));
    // Reset pagination to normal mode
    filterQueryRef.current = "";
    lastLoadedPageRef.current = 0;
    isFetchingRef.current = false;
    setCurrentPage(1);
    // Re-fetch the unfiltered chat history from page 1 and scroll to top
    getChatHistoryListingData(1);
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    searchRef.current = value;

    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      lastLoadedPageRef.current = 0;
      isFetchingRef.current = false;
      setCurrentPage(1);

      if (isHumanAgent) {
        const requesterId = scopedRequesterIdRef.current || requesterIdFromUrl;
        if (requesterId && filterQueryRef.current) {
          getChatHistoryByFiltering(filterQueryRef.current, 1, 100, value)
            .then((filtered) => {
              let scoped = filtered?.data?.data || filtered?.data || [];
              if (!Array.isArray(scoped)) scoped = [];
              scoped = scoped.filter((c) => resolveRequesterIdFromChat(c) === requesterId);
              searchResult(scoped);
            })
            .catch((err) => console.error(err));
        }
        return;
      }

      if (isFilterMode && filterQueryRef.current) {
        dispatch(getChatHistoryByFilter(filterQueryRef.current, 1, 20, value));
      } else {
        dispatch(getChatHistory(1, 20, value));
      }
    }, 500);
  };

  // Cleanup debounce timer on unmount
  useEffect(() => {
    return () => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
    };
  }, []);

  const handleClose = async () => {
    setopenDeleteBox(false);
  };

  const openMobileEditSettings = (historyId) => {
    setopenMobileSettings(historyId);
    setopenMobileSettingsOpenFlag(!MobileSettingsOpenFlag);
  };

  const today = new Date();
  let isToday = false;
  return (
    <div
      className={ChatHistoryOpen ? "chatHistoryLeftMobile" : "chatHistoryLeft"}
    >
      {showLoader && <Loader />}
      {!isHumanAgent && isFilterPopUpClick && clearFilterFromChild && filterData ? (
        <>
          <div className="ui card chat-screen filterBox">
            <h5>
              Applied Filters
              <span
                style={{ color: "red", fontSize: "12px", cursor: "pointer" }}
                onClick={clearFilter}
                data-cy="clear-filter-chat-click-cy"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clear all
              </span>
            </h5>
            {filterdataFromChild && clearFilterFromChild ? (
              <>
                <div className="filterOuterBox">
                  {filterdataFromChild.startDate ? (
                    <label
                      className="filterData startDate"
                      onClick={() => onStartDateClear({ startDate: null })}
                      value="StartDate"
                      style={{ cursor: "pointer" }}
                      data-cy="startdate-clear-cy"
                    >
                      {moment(filterStDate).format(
                        `${process.env.REACT_APP_DATE_FORMAT}`
                      )}

                      <img
                        src="/images/grey-close.svg"
                        alt="remove filter"
                        className="ui image"
                      ></img>
                    </label>
                  ) : (
                    ""
                  )}

                  {filterdataFromChild.endDate ? (
                    <label
                      className="filterData endDate"
                      onClick={() => onStartDateClear({ endDate: null })}
                      style={{ cursor: "pointer" }}
                      data-cy="enddate-clear-cy"
                    >
                      {moment(filterEdDate).format(
                        `${process.env.REACT_APP_DATE_FORMAT}`
                      )}
                      <img
                        src="/images/grey-close.svg"
                        alt="remove filter"
                        className="ui image"
                      ></img>
                    </label>
                  ) : (
                    ""
                  )}
                </div>

                {filterdataFromChild.datasets &&
                  filterdataFromChild.datasets.length > 0 ? (
                  <div className="filterOuterBox">
                    <label
                      className="filterData dataset"
                      onClick={() => onStartDateClear({ datasets: null })}
                      style={{ cursor: "pointer" }}
                      data-cy="dataset-clear-cy"
                    >
                      {filterdataFromChild.datasetNames
                        ? filterdataFromChild.datasetNames[0]
                        : ""}
                      <img
                        src="/images/grey-close.svg"
                        alt="remove filter"
                        className="ui image"
                      ></img>
                    </label>

                    {filterdataFromChild.datasets.length > 1 ? (
                      <label
                        className="filterData filterBlue"
                        onClick={handleFilterSort}
                        style={{ cursor: "pointer" }}
                        data-cy="more-open-search-filter-cy"
                      >
                        {`+ ${parseInt(
                          filterdataFromChild.datasets.length - 1
                        )} more`}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>


                ) : (
                  ""
                )}

                {filterdataFromChild.users &&
                  filterdataFromChild.users.length > 0 ? (
                  <div className="filterOuterBox">
                    <label
                      className="filterData dataset"
                      onClick={() => onStartDateClear({ users: null })}
                      style={{ cursor: "pointer" }}
                      data-cy="usernames-clear-cy"
                    >
                      {filterdataFromChild.userNames
                        ? filterdataFromChild.userNames[0]
                        : ""}
                      <img
                        src="/images/grey-close.svg"
                        alt="remove filter"
                        className="ui image"
                      ></img>
                    </label>

                    {filterdataFromChild.users.length > 1 ? (
                      <label
                        className="filterData filterBlue"
                        onClick={handleFilterSort}
                        style={{ cursor: "pointer" }}
                        data-cy="more-open-search-filter-cy"
                      >
                        {`+ ${parseInt(
                          filterdataFromChild.users.length - 1
                        )} more`}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>


                ) : (
                  ""
                )}
              </>
            ) : (
              <></>
            )}
          </div>

        </>
      ) : (
        <></>
      )}

      {isHumanAgent && chatBotQueryParam && requesterDisplayName ? (
        <Popup
          content={requesterDisplayName}
          position="top center"
          inverted
          disabled={requesterDisplayName.length <= 24}
          trigger={
            <div className="history-sidebar-caption">
              <div className="history-sidebar-caption-icon">
                <img src="/images/chat-history.svg" alt="" aria-hidden="true" />
              </div>
              <span className="history-sidebar-caption-name">{requesterDisplayName}</span>
            </div>
          }
        />
      ) : null}
      <div className="ai-chat-history">
        <Input
          fluid
          className="ai-search-input"
          placeholder="Search Chat name"
          value={searchInput}
          onChange={handleSearchChange}
          data-cy="search-chat-input-cy"
          disabled={isHumanAgent && !chatBotQueryParam}
        />
      </div>
      <br />
      <div className="chatHistoryScroll" ref={scrollRef}>
        {isHumanAgent && !chatBotQueryParam ? (
          <div className="chatHistoryOuter" style={{ padding: "16px", color: "#666", fontSize: "13px", lineHeight: 1.5 }}>
            Open a support request to view that user&apos;s chat history.
          </div>
        ) : isHumanAgent && chatBotQueryParam && showLoader ? (
          <div className="chat-history-loading">
            <div className="chat-history-loading-spinner"></div>
          </div>
        ) : isHumanAgent &&
          chatBotQueryParam &&
          chatHistoryLoaded &&
          (!data || data.length === 0) ? (
          <div className="history-sidebar-empty">No History</div>
        ) : data && data.length > 0 ? (
          data.map((item, key) => (
            <div className="chatHistoryOuter" key={key}>
              {Array.isArray(item.Chathistoryinfo) &&
                item.Chathistoryinfo !== undefined ? (
                <>
                  <h5>
                    &nbsp;
                    {item.localDate === moment(today).format("YYYY-MM-DD")
                      ? "Today"
                      : moment(item.localDate).format(
                        `${process.env.REACT_APP_DATE_FORMAT}`
                      )}
                    &nbsp;({item.Chathistoryinfo.length})
                  </h5>
                  {item.Chathistoryinfo.map((items, innerKey) => (
                    <div
                      key={innerKey}
                      className={`menu-item-search chatHistory 
                        ${selectedChatId === items.id ? "active-chat" : ""}
                        ${isEditable === items.id ? "inputHistory" : ""}`}
                    // onMouseOver={() => setIsHovered(items.id)}
                    // onMouseLeave={() => setIsHovered(null)}
                    >
                      {isEditable === items.id ? (
                        <>
                          <div className="chatHistoryOuter">
                            <label
                              ref={wrapperRef}
                              className={
                                showWarning
                                  ? "historyEditWarningLabel inputChatBox"
                                  : "inputChatBox"
                              }
                            >
                              <input
                                type="text"
                                value={chatInputValue}
                                onChange={(e) => chatEventUpdate(e, items.id)}
                                onKeyPress={(e) => handleEdit(e, items.id)}
                                className={
                                  showWarning
                                    ? "historyEditWarninginput inputChatBoxTxt"
                                    : "inputChatBoxTxt"
                                }
                                autoFocus
                              />
                            </label>
                            {showWarning && (
                              <p className="historyEditWarning">
                                Minimum limit 50 characters
                              </p>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="chatInfoBox">
                            <div className="chatBox">
                              <label
                                className="chat"
                                onClick={() =>
                                  handleView(
                                    items.id,
                                    items.Datasetname,
                                    items.DatasetID
                                  )
                                }
                                style={{ cursor: "pointer" }}
                                title={items.chathistoryname}
                                data-cy="chat-click-cy"
                              >
                                {items.chathistoryname !== undefined
                                  ? items.chathistoryname
                                  : ""}
                              </label>
                            </div>
                            <div className="datasetBox">
                              <label className="dataset">
                                {items.Datasetname}
                              </label>
                            </div>
                            {items.updatedUTC && (
                              <div className="chatTimestampBox">
                                <label className="chatTimestamp" data-cy="chat-history-timestamp">
                                  {formatMessageTimestampWithTz(items.updatedUTC)}
                                </label>
                              </div>
                            )}
                          </div>
                          <>
                            {!isHumanAgent && (
                            <div
                              className="mobile-dots-icon"
                              data-cy="chat-settings-click-cy"
                              onClick={() => openMobileEditSettings(items.id)}
                            >
                              <img
                                src="/images/chat-history-dots.svg"
                                alt="Settings"
                              />
                            </div>
                            )}
                            {openMobileSettings == items.id &&
                              MobileSettingsOpenFlag ? (
                              <>
                                {!isHumanAgent && (
                                <div className="settingsBoxMobile">
                                  <div>
                                    <p className="mobile-dot-dataset">
                                      <Popup
                                        content={items.Datasetname}
                                        trigger={
                                          <span>
                                            {items.Datasetname.length < 30
                                              ? items.Datasetname
                                              : items.Datasetname.slice(0, 30) +
                                              "..."}
                                          </span>
                                        }
                                        position="top center"
                                        inverted
                                      />
                                    </p>
                                    <p className="mobile-dot-chat-name">
                                      <Popup
                                        content={items.chathistoryname}
                                        trigger={
                                          <span>
                                            {items.chathistoryname.length < 50
                                              ? items.chathistoryname
                                              : items.chathistoryname.slice(
                                                0,
                                                50
                                              ) + "..."}
                                          </span>
                                        }
                                        position="top center"
                                        inverted
                                      />
                                    </p>
                                    <p className="mobile-dot-created-by">
                                      <Popup
                                        content={`Created By ${items.createdBy.display_name}`}
                                        trigger={
                                          <span>
                                            {items.createdBy.display_name
                                              .length < 50
                                              ? `Created By ${items.createdBy.display_name}`
                                              : `Created By ${items.createdBy.display_name.slice(
                                                0,
                                                50
                                              )}...`}
                                          </span>
                                        }
                                        position="top center"
                                        inverted
                                      />
                                    </p>
                                  </div>
                                  <div className="childIconMobile">
                                    <div className="mobile-dot-grey-icon">
                                      <div
                                        className="childIconMobile"
                                        onClick={() =>
                                          chatHistoryEdit(
                                            items.id,
                                            items.chathistoryname
                                          )
                                        }
                                      >
                                        <img
                                          src="/images/Edit.svg"
                                          alt="Edit"
                                          style={{
                                            cursor: "pointer",
                                            marginRight: 8,
                                          }}
                                          data-cy="chat-edit-click-cy"
                                        />
                                      </div>
                                      {/* <div className="childIconMobile">
                                          <img
                                            src="/images/grey-download.svg"
                                            alt="Edit"
                                            style={{
                                              cursor: "pointer",
                                              marginRight: 8,
                                            }}
                                            data-cy="chat-download-click-cy" />
                                        </div> */}
                                      <div
                                        className="childIconMobile"
                                        onClick={() =>
                                          handleDelete(
                                            items.id,
                                            items.chathistoryname
                                          )
                                        }
                                      >
                                        <img
                                          src="/images/grey-delete.svg"
                                          alt="Delete"
                                          style={{ cursor: "pointer" }}
                                          data-cy="chat-delete-click-cy"
                                        />
                                      </div>
                                    </div>
                                    <div className="mobile-dot-color-icon">
                                      <div
                                        className="childIconMobile"
                                        onClick={() =>
                                          chatHistoryEdit(
                                            items.id,
                                            items.chathistoryname
                                          )
                                        }
                                      >
                                        <img
                                          src="/images/blue-pen.svg"
                                          alt="Edit"
                                          style={{
                                            cursor: "pointer",
                                            marginRight: 8,
                                          }}
                                          data-cy="chat-edit-click-cy"
                                        />
                                      </div>
                                      {/* <div className="childIconMobile">
                                          <img
                                            src="/images/blue-download.svg"
                                            alt="Edit"
                                            style={{
                                              cursor: "pointer",
                                              marginRight: 8,
                                            }}
                                            data-cy="chat-download-click-cy" />
                                        </div> */}
                                      <div
                                        className="childIconMobile"
                                        onClick={() =>
                                          handleDelete(
                                            items.id,
                                            items.chathistoryname
                                          )
                                        }
                                      >
                                        <img
                                          src="/images/red-delete.svg"
                                          alt="Delete"
                                          style={{ cursor: "pointer" }}
                                          data-cy="chat-delete-click-cy"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                          {/*  )} */}
                        </>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                <div
                  key={item.unique_id}
                  className={`menu-item-search chatHistory ${isEditable === item.id ? "inputHistory" : ""
                    }`}
                // onMouseOver={() => setIsHovered(item.unique_id)}
                // onMouseLeave={() => setIsHovered(null)}
                >
                  <h5>
                    &nbsp;&nbsp;
                    {item.localDate === moment(today).format("YYYY-MM-DD")
                      ? "Today"
                      : moment(item.localDate).format(
                        `${process.env.REACT_APP_DATE_FORMAT}`
                      )}
                    {item.localDate === moment(today).format("YYYY-MM-DD")
                      ? (isToday = true)
                      : ""}
                  </h5>
                  {isEditable === item.Chathistoryinfo.id ? (
                    <>
                      <div>
                        <label className="inputChatBox">
                          <input
                            type="text"
                            value={chatInputValue}
                            onChange={(e) => setChatInputValue(e.target.value)}
                            onKeyPress={(e) =>
                              handleEdit(e, item.Chathistoryinfo.id)
                            }
                            className="inputChatBoxTxt"
                            data-cy="edit-chat-input-submit-cy"
                          />
                        </label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="chatBox">
                        {" "}
                        <label
                          className="chat"
                          onClick={() =>
                            handleView(
                              item.Chathistoryinfo.id,
                              item.Chathistoryinfo.Datasetname,
                              item.Chathistoryinfo.DatasetID
                            )
                          }
                          data-cy="chat-click-cy"
                        >
                          {item.Chathistoryinfo !== undefined &&
                            item.Chathistoryinfo.chathistoryname !== undefined
                            ? item.Chathistoryinfo.chathistoryname
                            : ""}
                        </label>
                      </div>
                      {isHovered == item.unique_id && !ChatHistoryOpen && !isHumanAgent ? (
                        <div>
                          <label className="dataset">
                            <img
                              src="/images/blue-pen.svg"
                              alt="Edit"
                              onClick={() =>
                                chatHistoryEdit(
                                  item.Chathistoryinfo.id,
                                  item.Chathistoryinfo.chathistoryname
                                )
                              }
                              style={{ cursor: "pointer", marginRight: 8 }}
                              data-cy="chat-edit-click-cy"
                            />
                            <img
                              src="/images/blue-download.svg"
                              alt="Edit"
                              style={{ cursor: "pointer", marginRight: 8 }}
                            />
                            <img
                              src="/images/red-delete.svg"
                              alt="Delete"
                              onClick={() =>
                                handleDelete(
                                  item.Chathistoryinfo.id,
                                  item.Datasetname
                                )
                              }
                              style={{ cursor: "pointer" }}
                              data-cy="chat-delete-click-cy"
                            />
                          </label>
                        </div>
                      ) : (
                        <div className="datasetBox">
                          <label className="dataset">{item.Datasetname}</label>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (loadingsChatHistory || !chatHistoryStatus || (responseChatHistory && responseChatHistory.length > 0)) ? (
          <div className="chat-history-loading">
            <div className="chat-history-loading-spinner"></div>
            <p className="chat-history-loading-text">Loading your chat history...</p>
          </div>
        ) : loading || isFilterPopUpClick ? (
          <div className="emptyContainer">
            <Image src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No chats found</span>
            </p>
          </div>
        ) : null}
        {isFetchingMore && (
          <div className="chat-history-loading" style={{ padding: '10px 0' }}>
            <div className="chat-history-loading-spinner"></div>
            <p className="chat-history-loading-text">Loading more chats...</p>
          </div>
        )}
      </div>
      <Modal
        open={openDeleteBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Delete Chat History</Header>

          <p>Are you sure you want to Delete "{deleteChatName}"</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-chat-delete-cy"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={actionDeleteChatHistory}
            data-cy="delete-chat-delete-cy"
          >
            Delete
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ChatHistory;
